import {OrganisationId} from '@/models/enums/OrganisationId';
import { AgentOpinion } from '@/modules/user/models/AgentOpinion';
import {Utils} from '@/services/utils/BasicUtils';

export interface AgentBranch {
  id: number;
  name: string;
  type: string;
  active: boolean;
  businessProfileUrl?: string;
}

export default class Agent {
  public id!: number;
  public userId!: number;
  public organisationId?: OrganisationId;
  public organisationUnitId?: number;
  public email: string = '';
  public name?: string = '';
  public firstName: string = '';
  public lastName: string = '';
  public phone?: string = '';
  public divisions: Array<number> = [];
  public url?: string = '';
  public photoUrl?: string = '';
  public canManageProspects?: boolean;
  public branch?: AgentBranch;
  public opinions?: AgentOpinion[];
  public rating?: number;

  get displayName(): string {
    return (this.firstName || this.lastName) ? `${this.firstName} ${this.lastName}` : '-';
  }

  constructor(dto?: Agent) {
    if (dto) {
      Utils.assign(this, dto);
    }
  }
}
